import React from 'react';

import { Form, Radio } from 'antd';

import { getIn } from 'formik';
import type { FieldProps } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';

interface IOption {
  label: string;
  value: string;
}

interface IProps extends FieldProps {
  label?: string;
  options: IOption[];
  row?: boolean;
}

export const ListRadioButtonFormField = ({ field, form, label, options, row }: IProps) => {
  const errorText = getIn(form.errors, field.name);

  return (
    <Form.Item className='mb-0 w-full' label={label} help={errorText} validateStatus={errorText ? 'error' : undefined}>
      <Hint inputName={field.name}>
        <Radio.Group value={field.value} onChange={e => form.setFieldValue(field.name, e.target.value)}>
          <div className={row ? 'flex flex-wrap gap-2' : 'flex flex-col gap-2'}>
            {options.map(op => (
              <Radio key={op.value} value={op.value}>
                {op.label}
              </Radio>
            ))}
          </div>
        </Radio.Group>
      </Hint>
    </Form.Item>
  );
};
